// extracted by mini-css-extract-plugin
module.exports = {"backIconWrapper":"NavigateBackButton_backIconWrapper__100ke","backIcon":"NavigateBackButton_backIcon__2PgkQ"};